import { Link, useNavigate } from 'react-router-dom';
import { getRetailAutomationPath } from '../helpers/urlHelper';
import ThumbnailCardUI from './ThumbnailCardUI';
import ThumbnailCardV2 from './ThumbnailCardV2';
import { useState } from 'react';
import Loader from './Loader';
import { useRetailAutomationActions } from '../hooks/useRetailAutomationActions';

export const ThumbnailCardRetailAutomation = ({
  data,
  size,
  fullWidth,
  onSelect,
  selected,
  hideFavourite,
  onDelete,
  customActions,
  onEdit,
  designV2,
  onDuplicatePass,
  isCollectionItem,
  isSharedItem,
  refetchData,
  ...rest
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const {
    onDelete: _onDelete,
    onFavouriteToggle,
    favouriteLoading,
    download,
    downloading,
    onShare,
    addToCollection,
    deleteSucess
  } = useRetailAutomationActions({
    item: data,
    isTemplateCard: rest.isTemplateCard,
  });
  const handleDelete = onDelete || _onDelete;
  const id = data.id;
  let extraprops = { ...rest };
  const url = extraprops.confFilter ? '' : getRetailAutomationPath(id);

  if (deleteSucess) {
    refetchData();
  }

  onEdit = () => {
    navigate(url);
  };

  const onDuplicate = (val) => {
    onDuplicatePass(val);
  };

  // product configurator I got thumb key for thumbnail
  const thumbnailImage = data?.thumbnail || data?.thumb;
  return designV2 ? (
    <>
      {loading ? <Loader loading={true} position="fixed" size={30} thickness={3} /> : null}

      <ThumbnailCardV2
        onFavouriteChange={onFavouriteToggle(data)}
        onSelect={onSelect}
        selected={selected}
        isFavourite={data.is_favourite}
        hideFavourite={hideFavourite}
        favouriteLoading={favouriteLoading}
        titleProps={{
          as: Link,
          to: url,
        }}
        // savePreviousRoute={true}
        id={data?.id}
        data={{ ...data, member_details: data?.created_by_details }}
        name={data?.name}
        thumbnail={thumbnailImage}
        images={data?.images}
        date={data.updated_at}
        showMenu
        showCheckbox
        isFavouriteIcon
        onEdit={onEdit}
        onDelete={handleDelete}
        // onShare={() => handleShareClick(data)}
        customActions={customActions}
        // onDownload={() => download(data?.id)}
        downloadLoading={downloading}
        fullWidth={fullWidth}
        // onAddToCollection={addToCollection}
        redirect={true}
        redirectTarget="_self"
        redirectURL={`${getRetailAutomationPath(data.id)}`}
        // onDuplicate={!isCollectionItem && !isSharedItem ? onDuplicate : null}
        userCard={true}
        // onInfoClick={handleInfoClick}
        // infoData={infoData}
        // infoLoading={infoLoading}
        {...rest}
      />
    </>
  ) : (
    <ThumbnailCardUI
      key={id}
      id={id}
      onEdit={onEdit}
      to={rest.isTemplateCard ? '' : url}
      thumbnail={thumbnailImage}
      images={data?.images}
      name={data.name}
      isFavourite={data.is_favourite}
      favouriteLoading={favouriteLoading}
      date={data.updated_at}
      onDelete={handleDelete}
    //   onShare={() => handleShareClick(data)}
      onFavouriteChange={onFavouriteToggle(data)}
      customActions={customActions}
      size={size}
      titleProps={{
        as: Link,
        to: url,
      }}
      // onDownload={() => download(data?.id)}
      downloadLoading={downloading}
      fullWidth={fullWidth}
      onSelect={onSelect}
      selected={selected}
    //   onAddToCollection={addToCollection}
      hideFavourite={hideFavourite}
      data={data}
      {...rest}
    />
  );
};
